import { ReactNode, useState, useRef, useEffect } from 'react';
import { Button } from 'react-aria-components';
import plusIcon from '@assets/icons/menu-plus-icon.svg';



interface CollapsibleProp {
	label: string,
	className: string,
	children: ReactNode,
}



const Collapsible = (props: CollapsibleProp) => {
	const { label, className, children } = props;

	const [ isOpen, setIsOpen ] = useState(false);
	const contentRef = useRef<HTMLDivElement>(null);

	
	useEffect(() => {
		if (isOpen && contentRef && contentRef.current) {
			setTimeout(() => contentRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 150);
		}
	}, [ isOpen, contentRef ]);

	
	return (
		<div className={`footer-section ${className}`}>
			
			<Button className={`collapsible-button disable-selection${isOpen ? ' active' : ''}`} onPress={() => setIsOpen(!isOpen)}>
				{label}
				<div className='collapsible-button-icon'>
					<img src={plusIcon} alt='footer-menu-button-icon' />
				</div>
			</Button>
			
			<div
				className='collapsible-content'
				style={{ maxHeight: isOpen && contentRef && contentRef.current ? `${contentRef.current.scrollHeight}px` : '0'}}
				ref={contentRef}>
				
				{children}
			</div>
		
		</div>
	);
}

export default Collapsible;